import { Drawer, DrawerContent, DrawerOverlay, DrawerPortal } from "@/components"
import { IconButton } from "@/elements"
import { XMarkIcon } from "@heroicons/react/24/outline"
import clsx from "clsx"
import React from "react"

interface Props {
  onClose: () => void
  open: boolean
  mainContent: React.ReactNode
  footer: React.ReactNode
  hideCloseOnMobile?: boolean
}

export const JobsSideDrawerFooterTemplate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div
      className="w-full rounded-tl-lg rounded-tr-lg border-t border-bg-3 bg-bg-1 px-5 md:rounded-tl-none md:rounded-tr-none md:px-10"
      style={{
        boxShadow: "0px 8px 25px 0px rgba(0, 0, 0, 0.20)",
      }}>
      <div className="flex w-full flex-row items-center py-4">{children}</div>
    </div>
  )
}

export const JobsSideDrawerTemplate: React.FC<Props> = ({
  onClose,
  open,
  mainContent,
  footer,
  hideCloseOnMobile = false,
}) => {
  return (
    <Drawer onOpenChange={onClose} open={open}>
      <DrawerPortal>
        <DrawerOverlay />
        <DrawerContent className="flex w-full !max-w-[100%] flex-col !gap-0 overflow-y-hidden border-none !px-0 !pb-0 !pt-0 md:w-[480px] lg:w-[600px]">
          <div className="relative flex h-full w-full flex-col">
            <div
              className={clsx(
                "z-10 h-[64px] shrink-0 flex-row items-center justify-end border-b border-bg-3 px-3",
                hideCloseOnMobile ? "hidden sm:flex" : "flex"
              )}>
              <IconButton Icon={XMarkIcon} variant="white" onClick={onClose} className="self-center" />
            </div>
            <div className="relative w-full flex-grow flex-col overflow-x-hidden overflow-y-scroll px-5 pb-5 sm:px-0">
              {mainContent}
            </div>
            <JobsSideDrawerFooterTemplate>{footer}</JobsSideDrawerFooterTemplate>
          </div>
        </DrawerContent>
      </DrawerPortal>
    </Drawer>
  )
}
